import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";

import { store } from "react-notifications-component";

import api from "../../services/api";
import estados from "../../services/estados";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";

import GenericUpper from "../../components/generic-upper";
import Agronomo from "../../components/creas/agronomos";
import Agronomov2 from "../../components/creas/agronomos/indexv2";
import AddCreas from "../../components/creas/creas";
import AcordionCard from "../../components/acordionCard";
import InputV3 from "../../components/input/novo/input_v3";
import InputSign from "../../components/inputSign";
import ModalPassword from "../../components/modal/modal_password";
import Modal from "../../components/modal";
import { ModalBody, ModalTitle } from "../../components/modal/styles";
import SelectV2Multi from "../../components/select/select_v2_multi";
import { IconUploads } from "../../assets/icons/iconUploads";
import PlanilhaDropzone, { formatFileSize } from "../../components/planilha-dropzone";

import plus from "../../assets/icons/plus.png";
import SignatureTypeCards from "../../components/signatureTypeCards";

import * as S from "./stylesCreaV2";
import { theme } from "../../styles/theme";
import {
  BodyP,
  H6,
  TaglineM,
  TaglineP,
} from "../../styles/stylesTypography";
import Button from "../../components/button/button_v2";
import Status from "../../components/Status";

export const USER = "@userinfo";

// Certificado A1: o navegador nem sempre preenche o mime do .pfx/.p12, entao as
// extensoes entram junto para o arquivo nao ser rejeitado na selecao.
const CERTIFICADO_ACCEPT = {
  "application/x-pkcs12": [".pfx", ".p12"],
};


const EditCreaV2 = ({ ...props }) => {
  const [title, setTitle] = useState("Dados do Responsável Técnico");
  const [step, setStep] = useState(1);

  const [nome, setNome] = useState("");
  const [cpf, setCpf] = useState("");
  const [align] = useState("center");
  const [email, setEmail] = useState("");
  const [enviar_receita, setEnviarReceita] = useState("");
  const [whatsapp, setWhatsapp] = useState("");

  const [licenca, setLicenca] = useState("");
  const [numeroLicenca, setNumeroLicenca] = useState("");
  const [filial, setFilial] = useState("");
  const [filiaisOptions, setFiliaisOptions] = useState([]);
  const [selectedMetod, setSelectedMetod] = useState("M");
  const [assinaturaEletronica, setAssinaturaEletronica] = useState("");
  const [assinaturaEletronicaPadrao, setAssinaturaEletronicaPadrao] = useState("");
  const [assinaturaDigitalPadrao, setAssinaturaDigitalPadrao] = useState("");
  const [assinaturaDigitalNomePadrao, setAssinaturaDigitalNomePadrao] = useState("");
  const [contractSoftId, setContractSoftId] = useState(0);

  const [idAgronomo, setIdAgronomo] = useState("");
  const [erroLicenca, setErroLicenca] = useState(false);
  // Modo usado quando aberto como modal a partir da tela de emissão de receita
  // (botão "Adicionar Novo" do CREA/VISTO/CFTA) - some os dados pessoais do
  // responsável (já cadastrado) e vai direto pro formulário de licença.
  const onlyCrea = !!props.onlyCrea;
  const autoOpenedLicenseForm = useRef(false);
  const idFromRoute =
    props?.idAgronomo ||
    props?.match?.params?.id ||
    (typeof window !== "undefined"
      ? window.location.pathname.split("/").filter(Boolean)[2]
      : "");

  const [tiposAssinatura, setTiposAssinatura] = useState([
    { value: 'M', label: 'Manual' },
    { value: 'D', label: 'Digital' },
    { value: 'E', label: 'Eletrônica' }
  ]);

  const [status, setStatus] = useState(false);

  const [loading, setLoading] = useState(true);
  const [emitiuReceita, setEmitiuReceita] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [uploadCertModal, setUploadCertModal] = useState(null);
  // Arquivo escolhido no dropzone, ainda nao aplicado: o certificado so e lido
  // quando o usuario confirma no "Salvar".
  const [certificadoSelecionado, setCertificadoSelecionado] = useState(null);
  const [signatureModal, setSignatureModal] = useState(null);
  const [file, setFile] = useState([]);
  const [textFile, setTextFile] = useState("");
  const [password, setPassword] = useState("");
  const [isValidate, setIsValidate] = useState(false);
  const [idCertificado, setIdCertificado] = useState("");
  const [creaLoading, setCreaLoading] = useState(false);
  const [assinaturaLoading, setAssinaturaLoading] = useState(false);
  const [currentCertificateContext, setCurrentCertificateContext] = useState(null);

  const getTiposAssinatura = async (estado) => {
    try {
        const response = await api.get(`/sign/estado/${estado}`);
        const tipos = response.data.data;
        let tipo = []

        if (tipos.manual === true) {
            tipo.push('M');
        }
        if (tipos.digital === true) {
            tipo.push('D');
        }
        if (tipos.eletronica === true) {
            tipo.push('E');
        }
        return tipo;

    } catch (error) {
        return ['M', 'D', 'E']; // fallback
    }
  }

  const [licenseForms, setLicenseForms] = useState([]);

  const [dataCreaCreated, setDataCreaCreated] = useState({});
  const [listCreasCreated, setListCreasCreated] = useState([]);
  const [openCreatedCreaIndex, setOpenCreatedCreaIndex] = useState(null);
  const [updatingCreatedCreaId, setUpdatingCreatedCreaId] = useState(null);
  const [savingLicenseIndex, setSavingLicenseIndex] = useState(null);

  const [
    showContentAcordionCloseAgronomist,
    setShowContentAcordionCloseAgronomist,
  ] = useState(false);
  const [showContentAcordionCloseCrea, setShowContentAcordionCloseCrea] =
    useState(false);

  useEffect(() => {
    const index = openCreatedCreaIndex;
    if (index === null || index === undefined) return;
    const crea = listCreasCreated[index];
    if (!crea?.id || !crea?.estado) return;
    if (Array.isArray(crea.allowedSignatures) && crea.allowedSignatures.length > 0)
      return;

    (async () => {
      const allowed = await getTiposAssinatura(crea.estado);
      setListCreasCreated((prev) =>
        prev.map((c) => (c?.id === crea.id ? { ...c, allowedSignatures: allowed } : c))
      );
    })();
  }, [openCreatedCreaIndex, listCreasCreated]);

  useEffect(() => {
    if (
      typeof assinaturaEletronicaPadrao !== "string" ||
      !assinaturaEletronicaPadrao.startsWith("data:image")
    ) {
      return;
    }

    setListCreasCreated((prev) => {
      let hasChanges = false;
      const next = prev.map((c) => {
        if ((c?.assinaturaDraft ?? c?.assinatura) !== "E") return c;
        if (c?.assinaturaEletronicaDraft === assinaturaEletronicaPadrao) return c;
        hasChanges = true;
        return { ...c, assinaturaEletronicaDraft: assinaturaEletronicaPadrao };
      });
      return hasChanges ? next : prev;
    });
  }, [assinaturaEletronicaPadrao]);

  useEffect(() => {
    if (
      typeof assinaturaEletronicaPadrao !== "string" ||
      !assinaturaEletronicaPadrao.startsWith("data:image")
    ) {
      return;
    }

    setLicenseForms((prev) => {
      let hasChanges = false;
      const next = prev.map((form) => {
        if (form?.selectedMetod !== "E") return form;
        if (form?.assinaturaEletronica === assinaturaEletronicaPadrao) return form;
        if (typeof form?.assinaturaEletronica === "string" && form.assinaturaEletronica.length > 0) {
          return form;
        }
        hasChanges = true;
        return {
          ...form,
          assinaturaEletronica: assinaturaEletronicaPadrao,
        };
      });
      return hasChanges ? next : prev;
    });
  }, [assinaturaEletronicaPadrao]);

  useEffect(() => {
    if (
      typeof assinaturaDigitalPadrao !== "string" ||
      !assinaturaDigitalPadrao.startsWith("data:")
    ) {
      return;
    }

    setListCreasCreated((prev) => {
      let hasChanges = false;
      const next = prev.map((c) => {
        if ((c?.assinaturaDraft ?? c?.assinatura) !== "D") return c;
        if (c?.certificadoDigitalDraft === assinaturaDigitalPadrao) return c;
        hasChanges = true;
        return {
          ...c,
          certificadoDigitalDraft: assinaturaDigitalPadrao,
          certificadoDigitalNomeDraft:
            c?.certificadoDigitalNomeDraft ||
            assinaturaDigitalNomePadrao ||
            "certificado_digital.pfx",
        };
      });
      return hasChanges ? next : prev;
    });
  }, [assinaturaDigitalNomePadrao, assinaturaDigitalPadrao]);

  useEffect(() => {
    if (
      typeof assinaturaDigitalNomePadrao !== "string" ||
      assinaturaDigitalNomePadrao.trim().length === 0
    ) {
      return;
    }

    setLicenseForms((prev) => {
      let hasChanges = false;
      const next = prev.map((form) => {
        if (form?.selectedMetod !== "D") return form;
        if (typeof form?.certificadoDigitalNome === "string" && form.certificadoDigitalNome.trim().length > 0) {
          return form;
        }
        hasChanges = true;
        return {
          ...form,
          certificadoDigitalNome: assinaturaDigitalNomePadrao,
        };
      });
      return hasChanges ? next : prev;
    });
  }, [assinaturaDigitalNomePadrao]);

  useEffect(() => {
    if (
      typeof assinaturaDigitalPadrao !== "string" ||
      !assinaturaDigitalPadrao.startsWith("data:")
    ) {
      return;
    }

    setLicenseForms((prev) => {
      let hasChanges = false;
      const next = prev.map((form) => {
        if (form?.selectedMetod !== "D") return form;
        const nextCertificadoNome =
          form?.certificadoDigitalNome ||
          assinaturaDigitalNomePadrao ||
          "certificado_digital.pfx";
        if (
          form?.certificadoDigital === assinaturaDigitalPadrao &&
          form?.certificadoDigitalNome === nextCertificadoNome
        ) {
          return form;
        }
        hasChanges = true;
        return {
          ...form,
          certificadoDigital: assinaturaDigitalPadrao,
          certificadoDigitalNome: nextCertificadoNome,
        };
      });
      return hasChanges ? next : prev;
    });
  }, [assinaturaDigitalNomePadrao, assinaturaDigitalPadrao]);

  const toggleLicenseForm = (index) => {
    const newForms = licenseForms.map((form, i) => {
      if (i === index) {
        return { ...form, isOpen: !form.isOpen };
      }
      return { ...form, isOpen: false }; // Fecha os outros
    });
    setLicenseForms(newForms);
  };

  const updateLicenseForm = (index, field, value) => {
    const newForms = [...licenseForms];
    newForms[index][field] = value;
    setLicenseForms(newForms);
  };

  const getSignatureModalValue = () => {
    if (!signatureModal) return "";
    if (signatureModal.type === "created") {
      const crea = listCreasCreated.find((c) => c?.id === signatureModal.creaId);
      return (
        crea?.assinaturaEletronicaDraft ||
        assinaturaEletronicaPadrao ||
        assinaturaEletronica ||
        ""
      );
    }
    const form = licenseForms[signatureModal.index];
    return (
      form?.assinaturaEletronica ||
      assinaturaEletronicaPadrao ||
      assinaturaEletronica ||
      ""
    );
  };

  const updateSignatureModalValue = async (value) => {
    if (!signatureModal) return;
    if (signatureModal.type === "created") {
      setListCreasCreated((prev) =>
        prev.map((c) =>
          c?.id === signatureModal.creaId ? { ...c, assinaturaEletronicaDraft: value } : c
        )
      );
    } else {
      updateLicenseForm(signatureModal.index, "assinaturaEletronica", value);
    }

    // Ao confirmar a assinatura (desenhada ou importada) já envia pra API na
    // hora, em vez de só guardar em rascunho e esperar o "SALVAR CREA/CFTA/
    // VISTO" - mesmo padrão já usado pra remover. Não dispara no reset do
    // "EDITAR ASSINATURA" (que chama update('') só pra voltar a desenhar),
    // por isso o startsWith('data:image').
    if (idAgronomo && typeof value === "string" && value.startsWith("data:image")) {
      await handlePutAgronomo(idAgronomo, { assinatura: value });
    }
  };

  const getCertificadoDigitalNome = (source) => {
    if (
      source &&
      Object.prototype.hasOwnProperty.call(source, "certificadoDigitalNomeDraft") &&
      source?.certificadoDigitalNomeDraft === ""
    ) {
      return "";
    }
    const possibleNames = [
      source?.certificadoDigitalNomeDraft,
      source?.certificadoDigitalNome,
      source?.certificado_digital_nome,
      source?.certificadoDigitalArquivoNome,
      source?.arquivo_certificado,
      source?.sign_arquivo,
      source?.arquivo,
      assinaturaDigitalNomePadrao,
    ];
    return (
      possibleNames.find(
        (name) => typeof name === "string" && name.trim().length > 0
      ) || ""
    );
  };

  const normalizeAssinaturaEletronica = (value) => {
    if (typeof value !== "string" || value.trim().length === 0) {
      return "";
    }
    if (value.startsWith("data:image")) {
      return value;
    }
    if (value.startsWith("data:application/octet-stream;base64,")) {
      return value.replace(
        "data:application/octet-stream;base64,",
        "data:image/png;base64,"
      );
    }
    if (value.startsWith("data:application/png;base64,")) {
      return value.replace("data:application/png;base64,", "data:image/png;base64,");
    }
    if (value.startsWith("data:application/jpg;base64,")) {
      return value.replace("data:application/jpg;base64,", "data:image/jpeg;base64,");
    }
    if (value.startsWith("data:application/jpeg;base64,")) {
      return value.replace("data:application/jpeg;base64,", "data:image/jpeg;base64,");
    }
    return "";
  };

  const getAssinaturaEletronicaFromSource = (source) => {
    const possibleSignatures = [
      source?.assinaturaEletronicaDraft,
      source?.assinaturaEletronica,
      source?.assinatura,
      source?.sign?.arquivo,
      source?.arquivo,
    ];
    return (
      possibleSignatures
        .map((signature) => normalizeAssinaturaEletronica(signature))
        .find((signature) => signature !== "") || ""
    );
  };

  const clearAssinaturaDigitalCompartilhada = () => {
    setAssinaturaDigitalPadrao("");
    setAssinaturaDigitalNomePadrao("");
    setLicenseForms((prev) =>
      prev.map((form) =>
        form?.selectedMetod === "D"
          ? {
              ...form,
              certificadoDigital: null,
              certificadoDigitalNome: "",
            }
          : form
      )
    );
    setListCreasCreated((prev) =>
      prev.map((c) =>
        (c?.assinaturaDraft ?? c?.assinatura) === "D"
          ? {
              ...c,
              certificadoDigitalDraft: null,
              certificadoDigitalNomeDraft: "",
            }
          : c
      )
    );
  };

  const getSignIdFromSource = (source) => {
    const possibleIds = [
      source?.sign,
      source?.sign?.id,
      source?.sign_id,
      source?.assinatura_id,
      source?.assinatura_digital_id,
      source?.id_sign,
      source?.certificadoDigitalId,
      source?.certificado_digital_id,
      source?.certificado_digital?.id,
    ];
    return (
      possibleIds.find(
        (value) =>
          typeof value === "number" ||
          (typeof value === "string" && value.trim().length > 0)
      ) || null
    );
  };

  const deleteDigitalSignature = async (source) => {
    setAssinaturaLoading(true)
    const signIdFromSource = getSignIdFromSource(source);
    const signId = signIdFromSource || idCertificado || null;
    if (!signId) return true;

    try {
      await api.delete(`/sign/delete/${signId}`);
      if (`${signId}` === `${idCertificado}`) {
        setIdCertificado("");
      }
      return true;
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(
          error,
          "ERRO-614 Nao foi possivel remover o certificado digital - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
      return false;
    } finally {
      setAssinaturaLoading(false)
    }
  };

  const validaCertificado = async (certificadoFile, certificadoPassword) => {
    setAssinaturaLoading(true)
    if (cpf) {
      if (certificadoFile && certificadoPassword) {
        const payload = {
          certificado: certificadoFile,
          cpf: cpf,
          senha: certificadoPassword,
        };
        try {
          let user = JSON.parse(localStorage.getItem(USER));
          const planFunctions = user?.contrato?.agro_plan_functions;
          let isBlock = false;

          if (Array.isArray(planFunctions)) {
            planFunctions.forEach((e) => {
              if (e?.agro_plans_function?.id === 9 && e?.status === 0) {
                isBlock = true;
              }
            });
          }

          if (isBlock === true) {
            closeModalPassword();
            store.addNotification({
              title: "Erro!",
              message: `A função de assinatura digital não está liberada para seu plano!`,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 4000,
                onScreen: true,
              },
            });
          } else {
            const response = await api.post(`/sign/digital`, payload);
            if (response) {
              setIsValidate(true);
              if (response?.data?.data?.id) {
                const signIdResponse = response.data.data.id;
                setIdCertificado(signIdResponse);
                if (currentCertificateContext?.type === "license") {
                  updateLicenseForm(currentCertificateContext.index, "sign_id", signIdResponse);
                }
                if (currentCertificateContext?.type === "created") {
                  setListCreasCreated((prev) =>
                    prev.map((c) =>
                      c?.id === currentCertificateContext.creaId
                        ? {
                            ...c,
                            sign_id: signIdResponse,
                          }
                        : c
                    )
                  );
                }
              }
            }
            setAssinaturaLoading(false)
            store.addNotification({
              title: "Sucesso!",
              message: `${response.data.data.msg}`,
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 4000,
                onScreen: true,
              },
            });
          }
        } catch (error) {
          setAssinaturaLoading(false)
          closeModalPassword();
          store.addNotification({
            title: "Erro!",
            message: identifyErrorMenssage(error, "ERRO-615 Erro ao validar o certificado digital - Tente novamente, se o erro persistir acione o suporte."),
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 4000,
              onScreen: true,
            },
          });
        }
      }
    } else {
      store.addNotification({
        title: "Erro!",
        message: `Informe o CPF!`,
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    }
  };

  const closeModalPassword = () => {
    setShowModal(false);
    setPassword("");
    if (currentCertificateContext?.type === "license") {
      updateLicenseForm(currentCertificateContext.index, "certificadoDigital", null);
      updateLicenseForm(currentCertificateContext.index, "certificadoDigitalNome", "");
      updateLicenseForm(currentCertificateContext.index, "sign_id", "");
    }
    if (currentCertificateContext?.type === "created") {
      setListCreasCreated((prev) =>
        prev.map((c) =>
          c?.id === currentCertificateContext.creaId
            ? {
                ...c,
                certificadoDigitalDraft: null,
                certificadoDigitalNomeDraft: "",
                sign_id: "",
              }
            : c
        )
      );
    }
    setCurrentCertificateContext(null);
    setTextFile("");
    setIsValidate(false);
  };

  const updatePassword = (value) => {
    setPassword(value);
    validaCertificado(file, value);
    setShowModal(false);
  };

  // Recebe o File direto do dropzone. Extensao, tamanho e arquivo unico ja sao
  // validados la, via accept/maxSize/maxFiles.
  // Fechar o modal descarta a escolha: o arquivo so conta depois do "Salvar",
  // senao reabrir mostraria um certificado que nunca foi aplicado.
  const fecharUploadCertModal = () => {
    setUploadCertModal(null);
    setCertificadoSelecionado(null);
  };

  const salvarCertificadoSelecionado = () => {
    if (!certificadoSelecionado) return;

    const context = uploadCertModal;
    const arquivo = certificadoSelecionado;
    fecharUploadCertModal();
    if (context) onSelectCertificate(arquivo, context);
  };

  const onSelectCertificate = (fileSelected, context) => {
    if (!fileSelected) return;

    let reader = new FileReader();
    reader.readAsDataURL(fileSelected);

    reader.onload = (event) => {
      const certificateBase64 = event.target.result;
      setIsValidate(false);
      setIdCertificado("");
      setFile(certificateBase64);
      setTextFile(certificateBase64);
      setCurrentCertificateContext(context);
      setAssinaturaDigitalNomePadrao(fileSelected.name);

      if (context?.type === "license") {
        updateLicenseForm(context.index, "certificadoDigital", certificateBase64);
        updateLicenseForm(context.index, "certificadoDigitalNome", fileSelected.name);
        updateLicenseForm(context.index, "sign_id", "");
      }
      if (context?.type === "created") {
        setListCreasCreated((prev) =>
          prev.map((c) =>
            c?.id === context.creaId
              ? {
                  ...c,
                  certificadoDigitalDraft: certificateBase64,
                  certificadoDigitalNomeDraft: fileSelected.name,
                  sign_id: "",
                }
              : c
          )
        );
      }

      if (cpf) {
        setShowModal(true);
      } else {
        store.addNotification({
          title: "Erro!",
          message: `Informe o CPF!`,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });
      }
    };
  };

  const validateFields = (index) => {
    let isValid = true;
    const form = licenseForms[index];
    const newForms = [...licenseForms];

    if (!form.licenca?.value) {
      newForms[index].erroLicenca = true;
      isValid = false;
    }

    if (!form.estadoLicenca?.value) {
      newForms[index].erroEstado = true;
      isValid = false;
    }

    if (!form.numeroLicenca) {
      newForms[index].erroNumeroLicenca = true;
      isValid = false;
    }

    if (!form.filial?.value) {
      newForms[index].erroFilial = true;
      isValid = false;
    }

    if (!form.selectedMetod) {
      newForms[index].erroMetodo = true;
      isValid = false;
    }

    if ((form.estadoLicenca?.value === "SC" || form.estadoLicenca?.value === "ES") && contractSoftId !== 6) {
        if (!form.usuario) {
            newForms[index].erroUsuario = true;
            isValid = false;
        }
        if (!form.senha) {
            newForms[index].erroSenha = true;
            isValid = false;
        }
    }

    if (form.estadoLicenca?.value === "RJ") {
        if (!form.receitaInicial) {
            newForms[index].erroReceitaInicial = true;
            isValid = false;
        }
    }

    setLicenseForms(newForms);

    if (!isValid) {
      store.addNotification({
        title: "Erro",
        message: "Preencha todos os campos obrigatórios",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
    }

    return isValid;
  };

  const handlePostAgronomo = async (e) => {
    try {
      const payload = {
        nome: nome,
        cpf: cpf,
        email: email,
        enviar_receita: enviar_receita,
        whatsapp: whatsapp,
        // enviar_alerta: sendWhatsapp,
        assinatura: selectedMetod ? selectedMetod : "",
      };

      const response = await api.post(`/agronomos`, payload);

      if (response) {
        store.addNotification({
          title: "Sucesso",
          message: "Responsável técnico cadastrado com sucesso",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
        setIdAgronomo(response.data.data.id);
        return response.data.data.id;
      }
    } catch (e) {
    } finally {
    }
  };

  const buildCreaPayloadFromForm = (form, nextStatus) => {
    return {
      estado: form.estadoLicenca.value,
      homologar_automatico:
        (form.estadoLicenca.value === "MT" ||
          form.estadoLicenca.value === "SC" ||
          form.estadoLicenca.value === "ES" ||
          form.estadoLicenca.value === "GO" ||
          form.estadoLicenca.value === "DF" ||
          form.estadoLicenca.value === "NACIONAL") &&
        contractSoftId !== 6
          ? 1
          : 0,
      crea: form.numeroLicenca,
      tipo: form.licenca.value,
      status: nextStatus,
      receita_inicial: form.receitaInicial || "",
      receitas_emitidas: "",
      filial: form.filial.value,
      assinatura: form.selectedMetod,
      usuario: form.usuario || "",
      senha: form.senha || "",
    };
  };

  const handlePostCrea = async (e, id, index) => {
    try {
      const form = licenseForms[index];
      const payload = buildCreaPayloadFromForm(form, 1);

      const response = await api.post(`/agronomos/${id}/creas`, payload);

      if (response.status === 201) {
        setErroLicenca(false);
        let assinaturaPayload = "";
        let certificadoDigitalNomePayload = "";

        if (
          form.selectedMetod === "E" &&
          typeof form.assinaturaEletronica === "string" &&
          form.assinaturaEletronica.startsWith("data:image")
        ) {
          assinaturaPayload = form.assinaturaEletronica;
        } else if (
          form.selectedMetod === "D" &&
          typeof form.certificadoDigital === "string" &&
          form.certificadoDigital.startsWith("data:")
        ) {
          assinaturaPayload = form.certificadoDigital;
          certificadoDigitalNomePayload = form.certificadoDigitalNome || "";
        } else if (form.selectedMetod === "M") {
          assinaturaPayload = "";
          certificadoDigitalNomePayload = "";
        }

        if (id) {
          const updated = await handlePutAgronomo(id, {
            assinatura: assinaturaPayload,
            certificadoDigitalNome: certificadoDigitalNomePayload,
          });
          if (!updated) return;
        }

        if (form.selectedMetod === "E" && assinaturaPayload.startsWith("data:image")) {
          setAssinaturaEletronica(assinaturaPayload);
          setAssinaturaEletronicaPadrao(assinaturaPayload);
          setLicenseForms((prev) =>
            prev.map((licenseForm) =>
              licenseForm?.selectedMetod === "E"
                ? { ...licenseForm, assinaturaEletronica: assinaturaPayload }
                : licenseForm
            )
          );
        }

        if (form.selectedMetod === "D" && assinaturaPayload.startsWith("data:")) {
          setAssinaturaDigitalPadrao(assinaturaPayload);
          setLicenseForms((prev) =>
            prev.map((licenseForm) =>
              licenseForm?.selectedMetod === "D"
                ? {
                    ...licenseForm,
                    certificadoDigital: assinaturaPayload,
                    certificadoDigitalNome:
                      licenseForm?.certificadoDigitalNome ||
                      form.certificadoDigitalNome ||
                      assinaturaDigitalNomePadrao ||
                      "certificado_digital.pfx",
                  }
                : licenseForm
            )
          );
          if (
            typeof form.certificadoDigitalNome === "string" &&
            form.certificadoDigitalNome.trim().length > 0
          ) {
            setAssinaturaDigitalNomePadrao(form.certificadoDigitalNome);
          }
        }

        if (form.usuario && form.senha) {
             if (form.estadoLicenca.value === 'ES') {
                 await api.post(`/agronomos/usuario/${id}/ES`, {
                     usuario: form.usuario,
                     senha: form.senha
                 });
             }
             if (form.estadoLicenca.value === 'SC') {
                 await api.post(`/agronomos/usuario/${id}/SC`, {
                     usuario: form.usuario,
                     senha: form.senha
                 });
             }
         }

        setListCreasCreated((prev) => [
          ...prev,
          {
            ...response.data.data,
            payloadSnapshot: payload,
            allowedSignatures: form.allowedSignatures,
            assinaturaEletronicaDraft:
              form.selectedMetod === "E" ? form.assinaturaEletronica || "" : "",
            certificadoDigitalDraft:
              form.selectedMetod === "D" ? form.certificadoDigital || null : null,
            certificadoDigitalNomeDraft:
              form.selectedMetod === "D"
                ? form.certificadoDigitalNome ||
                  getCertificadoDigitalNome(response?.data?.data) ||
                  assinaturaDigitalNomePadrao ||
                  "certificado_digital.pfx"
                : "",
          },
        ]);
        setOpenCreatedCreaIndex(null);

        setShowContentAcordionCloseCrea(true);
        setStatus(true);
        store.addNotification({
          title: "Sucesso",
          message: "Crea cadastrado com sucesso",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });

        // Remove the saved form from the list
        const newForms = licenseForms.filter((_, i) => i !== index);
        setLicenseForms(newForms);

        setStep(0);
      }
    } catch (e) {
      const errorMessage = identifyErrorMenssage(
        e,
        "Houve um problema para cadastrar o CREA/Visto/CFTA"
      );

      if (e?.response?.status === 422) {
        setErroLicenca(true)
      }

      store.addNotification({
        title: "Erro",
        message: errorMessage,
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
    } finally {
    }
  };

  const handleCreateAgronomistAndCrea = async (e, index) => {
    if (!validateFields(index)) return;

    try {
      setSavingLicenseIndex(index);
      if (idAgronomo) {
        await handlePostCrea(e, idAgronomo, index);
      } else {
        setStep(0);
        const id = await handlePostAgronomo(e);
        if (id) {
          await handlePostCrea(e, id, index);
        }
      }
    } catch (e) {
    } finally {
      setSavingLicenseIndex(null);
    }
  };

  const updateAgronomoInfo = async (
    nome,
    cpf,
    email,
    enviar,
    whatsapp,
    sendWhatsapp
  ) => {
    setNome(nome);
    setCpf(cpf);
    setEmail(email);
    setEnviarReceita(enviar);
    setWhatsapp(whatsapp);
  };

  const handlePutAgronomo = async (id, data) => {
    setCreaLoading(true)
    try {
      const assinaturaFromForms =
        listCreasCreated.find(
          (crea) =>
            (crea?.assinaturaDraft ?? crea?.assinatura) === "E" &&
            typeof crea?.assinaturaEletronicaDraft === "string" &&
            crea.assinaturaEletronicaDraft.startsWith("data:image")
        )?.assinaturaEletronicaDraft || "";
      const assinaturaDigitalFromForms =
        listCreasCreated.find(
          (crea) =>
            (crea?.assinaturaDraft ?? crea?.assinatura) === "D" &&
            typeof crea?.certificadoDigitalDraft === "string" &&
            crea.certificadoDigitalDraft.startsWith("data:")
        )?.certificadoDigitalDraft || "";

      const assinaturaPayload =
        data &&
        typeof data.assinatura === "string" &&
        (data.assinatura === "" || data.assinatura.startsWith("data:"))
          ? data.assinatura
          : assinaturaDigitalFromForms ||
            (typeof assinaturaDigitalPadrao === "string" &&
            assinaturaDigitalPadrao.startsWith("data:")
              ? assinaturaDigitalPadrao
              : "") ||
            assinaturaFromForms ||
            (typeof assinaturaEletronicaPadrao === "string" &&
            assinaturaEletronicaPadrao.startsWith("data:image")
              ? assinaturaEletronicaPadrao
              : "") ||
            assinaturaEletronica ||
            "";

      const payload = {
        nome: data?.nome ?? nome,
        cpf: data?.cpf ?? cpf,
        email: data?.email ?? email,
        enviar_receita: data?.enviar_receita ?? enviar_receita,
        whatsapp: data?.whatsapp ?? whatsapp,
        assinatura: assinaturaPayload,
      };

      const response = await api.put(`/agronomos/${id}`, payload);

      if (response.status === 200) {
        if (
          typeof assinaturaPayload === "string" &&
          assinaturaPayload.startsWith("data:image")
        ) {
          setAssinaturaEletronica(assinaturaPayload);
          setAssinaturaEletronicaPadrao(assinaturaPayload);
        } else if (
          typeof assinaturaPayload === "string" &&
          assinaturaPayload.startsWith("data:")
        ) {
          setAssinaturaDigitalPadrao(assinaturaPayload);
          if (
            typeof data?.certificadoDigitalNome === "string" &&
            data.certificadoDigitalNome.trim().length > 0
          ) {
            setAssinaturaDigitalNomePadrao(data.certificadoDigitalNome);
          }
        } else if (assinaturaPayload === "") {
          clearAssinaturaDigitalCompartilhada();
        }
        store.addNotification({
          title: "Sucesso",
          message: "Responsável técnico atualizado com sucesso",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });

        loadAgronomo(id);
        return true;
      }
    } catch (e) {
      store.addNotification({
        title: "Erro",
        message: identifyErrorMenssage(
          e,
          "ERRO-616 Nao foi possivel atualizar o responsavel tecnico - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      return false;
    } finally {
      setCreaLoading(true)
    }
  };

  const getTipoAssinaturaFromCrea = (crea) => {
    const fromTipoAssinatura = crea?.tipo_assinatura;
    if (fromTipoAssinatura === "M" || fromTipoAssinatura === "D" || fromTipoAssinatura === "E") {
      return fromTipoAssinatura;
    }
    const fromAssinatura = crea?.assinatura;
    if (fromAssinatura === "M" || fromAssinatura === "D" || fromAssinatura === "E") {
      return fromAssinatura;
    }
    return "M";
  };

  const mapCreaFromApi = (c, agronomoIdValue) => {
    const filialId = c?.filial?.id ?? c?.filial;
    const assinaturaTipo = getTipoAssinaturaFromCrea(c);
    const assinaturaEletronicaFromApi = getAssinaturaEletronicaFromSource(c);
    const snapshot = {
      estado: c?.estado,
      crea: c?.crea,
      tipo: c?.tipo,
      filial: filialId,
      agro_agronomist_id: c?.agronomo?.id ?? c?.agro_agronomist_id ?? Number(agronomoIdValue),
      receita_inicial: c?.receita_inicial === "" ? 0 : c?.receita_inicial ?? 0,
      receitas_emitidas: c?.receitas_emitidas ?? 0,
      status: c?.status,
      assinatura: assinaturaTipo,
      homologar_automatico: c?.homologar_automatico,
      usuario: c?.usuario ?? "",
      senha: c?.senha ?? "",
    };

    return {
      ...c,
      assinatura: assinaturaTipo,
      assinaturaEletronicaDraft:
        assinaturaTipo === "E" ? assinaturaEletronicaFromApi : "",
      certificadoDigitalDraft:
        assinaturaTipo === "D" &&
        typeof assinaturaDigitalPadrao === "string" &&
        assinaturaDigitalPadrao.startsWith("data:")
          ? assinaturaDigitalPadrao
          : null,
      certificadoDigitalNomeDraft:
        assinaturaTipo === "D" ? getCertificadoDigitalNome(c) : "",
      allowedSignatures: c?.allowedSignatures ?? [],
      payloadSnapshot: snapshot,
    };
  };

  const loadAgronomo = async (id) => {
    try {
      const response = await api.get(`/agronomos/${id}`);

      if (response.status === 200 ){
          const data = response.data.data;

          const dadosCompletos = !!data.nome && !!data.cpf;
          setStep(dadosCompletos ? 0 : 1);
          setShowContentAcordionCloseAgronomist(dadosCompletos)
          setNome(data.nome);
          setCpf(data.cpf);
          setEmail(data.email);
          setEnviarReceita(data.enviar_receita);
          setWhatsapp(data.whatsapp);
          setEmitiuReceita(!!response.data.emitiu_receita);

          const assinaturaFromApi = data.assinatura;
          const assinaturaEletronicaFromApi = normalizeAssinaturaEletronica(assinaturaFromApi);
          const nomeCertificadoSalvo = getCertificadoDigitalNome(data);

          if (assinaturaFromApi && typeof assinaturaFromApi === "string") {
            if (assinaturaEletronicaFromApi) {
              setSelectedMetod("E");
              setAssinaturaEletronica(assinaturaEletronicaFromApi);
              setAssinaturaEletronicaPadrao(assinaturaEletronicaFromApi);
              setAssinaturaDigitalPadrao("");
              setAssinaturaDigitalNomePadrao("");
            } else if (assinaturaFromApi.startsWith("data:")) {
              setSelectedMetod("D");
              setAssinaturaDigitalPadrao(assinaturaFromApi);
              if (nomeCertificadoSalvo) {
                setAssinaturaDigitalNomePadrao(nomeCertificadoSalvo);
              }
              setAssinaturaEletronica("");
              setAssinaturaEletronicaPadrao("");
            } else if (
              assinaturaFromApi === "M" ||
              assinaturaFromApi === "D" ||
              assinaturaFromApi === "E"
            ) {
              setSelectedMetod(assinaturaFromApi);
              setAssinaturaEletronica("");
              setAssinaturaEletronicaPadrao("");
            } else {
              setSelectedMetod("M");
              setAssinaturaEletronica("");
              setAssinaturaEletronicaPadrao("");
            }
          } else {
            setSelectedMetod("M");
            setAssinaturaEletronica("");
            setAssinaturaEletronicaPadrao("");
          }
          return data;
      }
    } catch (e) {
      store.addNotification({
        title: "Erro",
        message: identifyErrorMenssage(
          e,
          "ERRO-617 Nao foi possivel buscar dados do responsavel tecnico - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
    }
    return null;
  };

  const loadCreas = async (id) => {
    try {
      const response = await api.get(`/agronomos/${id}/creas`);
      if(response.status === 200) {
          const creas = Array.isArray(response?.data?.data) ? response.data.data : [];
          const assinaturaEletronicaCompartilhada = creas
            .map((c) => getAssinaturaEletronicaFromSource(c))
            .find((assinatura) => assinatura !== "");
          if (assinaturaEletronicaCompartilhada) {
            setAssinaturaEletronica(assinaturaEletronicaCompartilhada);
            setAssinaturaEletronicaPadrao(assinaturaEletronicaCompartilhada);
          }
          const assinaturaDigitalCompartilhada = creas
            .map((c) => c?.assinatura)
            .find(
              (assinatura) =>
                typeof assinatura === "string" &&
                assinatura.startsWith("data:") &&
                !assinatura.startsWith("data:image")
            );
          if (assinaturaDigitalCompartilhada) {
            setAssinaturaDigitalPadrao(assinaturaDigitalCompartilhada);
          }
          const nomeCertificado = creas
            .map((c) => getCertificadoDigitalNome(c))
            .find((name) => typeof name === "string" && name.trim().length > 0);
          if (nomeCertificado) {
            setAssinaturaDigitalNomePadrao(nomeCertificado);
          }
    
          setListCreasCreated(
            creas.map((c) => mapCreaFromApi(c, id))
          )
        }
    } catch (e) {
      setListCreasCreated([]);

      store.addNotification({
        title: "Erro",
        message: identifyErrorMenssage(
          e,
          "ERRO-618 Nao foi possivel buscar dados de CREA/Visto/CFTA - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
    }
  };

  const LoadingAgronomoAndCrea = async (id) => {
    setLoading(true);
    const agronomo = await loadAgronomo(id);
    const creasFromAgronomo = Array.isArray(agronomo?.creas) ? agronomo.creas : null;

    if (creasFromAgronomo) {
      const assinaturaEletronicaCompartilhada = creasFromAgronomo
        .map((c) => getAssinaturaEletronicaFromSource(c))
        .find((assinatura) => assinatura !== "");
      if (assinaturaEletronicaCompartilhada) {
        setAssinaturaEletronica(assinaturaEletronicaCompartilhada);
        setAssinaturaEletronicaPadrao(assinaturaEletronicaCompartilhada);
      }
      const assinaturaDigitalCompartilhada = creasFromAgronomo
        .map((c) => c?.assinatura)
        .find(
          (assinatura) =>
            typeof assinatura === "string" &&
            assinatura.startsWith("data:") &&
            !assinatura.startsWith("data:image")
        );
      if (assinaturaDigitalCompartilhada) {
        setAssinaturaDigitalPadrao(assinaturaDigitalCompartilhada);
      }
      const nomeCertificado = creasFromAgronomo
        .map((c) => getCertificadoDigitalNome(c))
        .find((name) => typeof name === "string" && name.trim().length > 0);
      if (nomeCertificado) {
        setAssinaturaDigitalNomePadrao(nomeCertificado);
      }
      setListCreasCreated(
        creasFromAgronomo.map((c) => mapCreaFromApi(c, id))
      );
    } else {
      await loadCreas(id);
    }
    setLoading(false);
  }

  const updateCreatedCreaStatus = async (creaItemOrId, newStatus, newAssinatura, newUsuario, newSenha) => {
    const creaId =
      typeof creaItemOrId === "object" ? creaItemOrId?.id : creaItemOrId;
    const snapshot =
      typeof creaItemOrId === "object" ? creaItemOrId?.payloadSnapshot : null;

    try {
      setUpdatingCreatedCreaId(creaId);

      if (snapshot && creaId) {
        setCreaLoading(true)
        const response = await api.put(`/creas/${creaId}`, {
          ...snapshot,
          receita_inicial: snapshot?.receita_inicial === "" ? 0 : snapshot?.receita_inicial,
          status: newStatus,
          assinatura: newAssinatura ?? snapshot?.assinatura,
          usuario: newUsuario ?? snapshot?.usuario ?? "",
          senha: newSenha ?? snapshot?.senha ?? "",
        });
        if (response?.status === 200) {
          const agronomoIdToRefresh = idAgronomo || idFromRoute;
          if (agronomoIdToRefresh) {
            await LoadingAgronomoAndCrea(agronomoIdToRefresh);
          }
          setCreaLoading(false)
          store.addNotification({
            title: "Sucesso",
            message: "CREA/Visto/CFTA atualizado com sucesso",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
          return true;
        }
      }

      const responseCrea = await api.get(`/creas/${creaId}`);
      const current = responseCrea?.data?.data;

      const payload = {
        estado: current?.estado,
        crea: current?.crea,
        tipo: current?.tipo,
        filial:
          current?.filial?.id ??
          current?.filial ??
          current?.agronomo?.filial?.id ??
          current?.agronomo?.filial?.nome_fantasia,
        agro_agronomist_id: current?.agronomo?.id ?? current?.agro_agronomist_id,
        receita_inicial: current?.receita_inicial === "" ? 0 : current?.receita_inicial,
        receitas_emitidas: current?.receitas_emitidas ?? 0,
        status: newStatus,
        assinatura: newAssinatura ?? current?.assinatura,
        homologar_automatico: current?.homologar_automatico,
        usuario: newUsuario ?? current?.usuario ?? "",
        senha: newSenha ?? current?.senha ?? "",
      };

      const response = await api.put(`/creas/${creaId}`, payload);
      if (response?.status === 200) {
        const agronomoIdToRefresh = idAgronomo || idFromRoute;
        if (agronomoIdToRefresh) {
          await LoadingAgronomoAndCrea(agronomoIdToRefresh);
        }
        store.addNotification({
          title: "Sucesso",
          message: "CREA/Visto/CFTA atualizado com sucesso",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
        return true;
      }
      return false;
    } catch (e) {
      store.addNotification({
        title: "Erro",
        message: identifyErrorMenssage(
          e,
          "ERRO-619 Nao foi possivel atualizar o status da licenca - Tente novamente, se o erro persistir acione o suporte."
        ),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      return false;
    } finally {
      setUpdatingCreatedCreaId(null);
    }
  };

  const getFiliais = async () => {
    try {
      const response = await api.get(`/filiais`);
      const filiais = response.data.data;

      if (filiais.length) {
        const formatFiliais = filiais.map((f) => {
          let format = {
            value: f.id,
            label: f.nome_fantasia,
          };
          return format;
        });

        if (filiais && filiais.length > 0) {
          setFiliaisOptions(formatFiliais);
        } else {
          setFiliaisOptions(formatFiliais);
        }
      } else {
        const formatFiliais = [
          { value: filiais.id, label: filiais.nome_fantasia },
        ];
        setFiliaisOptions(formatFiliais);
      }
    } catch (e) {}
  };

  useEffect(() => {
    getFiliais();

    
    let user = JSON.parse(localStorage.getItem(USER));
    if (user.contrato.agro_plan_config.is_teste === 0) {
            setContractSoftId(8);
        } else {
            setContractSoftId(6);
        }
  }, []);

  useEffect(() => {
    if (!idFromRoute) return;
    setIdAgronomo(idFromRoute);
    LoadingAgronomoAndCrea(idFromRoute);
  }, [idFromRoute]);

  // No modo "só licença" (aberto como modal a partir da emissão de receita): sempre
  // abre o formulário de licença em branco pra pessoa preencher direto, já trazendo
  // o estado (UF) da receita que está sendo emitida.
  useEffect(() => {
    if (!onlyCrea) return;
    if (loading) return;
    if (autoOpenedLicenseForm.current) return;
    if (licenseForms.length > 0) return;

    autoOpenedLicenseForm.current = true;

    const estadoValueDaReceita =
      typeof props.estado === "object" ? props.estado?.value : props.estado;
    const estadoDaReceita = estadoValueDaReceita
      ? estados.find((e) => e.value === estadoValueDaReceita) ||
        { value: estadoValueDaReceita, label: props.estado?.label || estadoValueDaReceita }
      : "";

    (async () => {
      const allowedSignatures = estadoDaReceita
        ? await getTiposAssinatura(estadoDaReceita.value)
        : ["M", "D", "E"];

      setLicenseForms([
        {
          id: Date.now(),
          licenca: estadoDaReceita?.value === "NACIONAL" ? { value: "cfta", label: "CFTA" } : "",
          estadoLicenca: estadoDaReceita,
          numeroLicenca: "",
          filial: filiaisOptions.length === 1 ? filiaisOptions[0] : "",
          selectedMetod: assinaturaDigitalPadrao
            ? "D"
            : assinaturaEletronicaPadrao
            ? "E"
            : "M",
          receitaInicial: "",
          assinaturaEletronica: assinaturaEletronicaPadrao || "",
          certificadoDigital: assinaturaDigitalPadrao || null,
          certificadoDigitalNome: assinaturaDigitalPadrao
            ? assinaturaDigitalNomePadrao || "certificado_digital.pfx"
            : "",
          allowedSignatures,
          erroLicenca: false,
          erroEstado: false,
          erroNumeroLicenca: false,
          erroFilial: false,
          erroMetodo: false,
          isOpen: true,
        },
      ]);
    })();
  }, [
    onlyCrea,
    loading,
    licenseForms,
    filiaisOptions,
    assinaturaDigitalPadrao,
    assinaturaEletronicaPadrao,
    assinaturaDigitalNomePadrao,
    props.estado,
  ]);

  useEffect(() => {
    if (filiaisOptions.length !== 1) return;
    const onlyOption = filiaisOptions[0];

    setLicenseForms((prev) =>
      prev.map((form) => {
        const hasFilialSelected =
          typeof form?.filial === "object" && !!form?.filial?.value;
        if (hasFilialSelected) return form;
        return { ...form, filial: onlyOption, erroFilial: false };
      })
    );
  }, [filiaisOptions]);

  return (
    <>
      {!onlyCrea && (
        <GenericUpper
          align={align}
          title={title}
          help
          text={"Dúvidas para cadastrar um responsável técnico?"}
          toSearch={"https://agroreceita.com.br/cadastro-responsavel-tecnico/"}
          textToSearch={"Clique aqui e acesse o tutorial!"}
        ></GenericUpper>
      )}

      <S.Container isModal={props.isModal}>
        <S.Wrapper>


        {loading ? (
            <S.LoadingWrapper isModal={props.isModal}>
                <S.Loading color={theme.colors.green.Verde_AgroReceita} isModal={props.isModal} />
            </S.LoadingWrapper>
        ):(
            <>
                {!onlyCrea && (
                <AcordionCard
                    title={nome ? nome : `Dados do Responsável Técnico`}
                    isOpen={step === 1}
                    showContentAcordionClose={showContentAcordionCloseAgronomist}
                    contentAcordionClose={
                    <S.ContainerContentAcordionClose>
                        <S.InformationAcordionClose>
                        <TaglineP>E-mail</TaglineP>

                        <BodyP fontWeight={theme.typography.fontWeight.bold}>
                            {email}
                        </BodyP>
                        </S.InformationAcordionClose>

                        <S.InformationAcordionClose>
                        <TaglineP>CPF</TaglineP>

                        <BodyP fontWeight={theme.typography.fontWeight.bold}>
                            {cpf}
                        </BodyP>
                        </S.InformationAcordionClose>

                        {whatsapp && (
                        <S.InformationAcordionClose>
                            <TaglineP>Whatsapp</TaglineP>

                            <BodyP fontWeight={theme.typography.fontWeight.bold}>
                            {whatsapp}
                            </BodyP>
                        </S.InformationAcordionClose>
                        )}
                    </S.ContainerContentAcordionClose>
                    }
                >
                    <Agronomov2
                    nome={nome}
                    cpf={cpf}
                    email={email}
                    enviar_receita={enviar_receita}
                    whatsapp={whatsapp}
                    agronomoId={idAgronomo}
                    assinatura={selectedMetod}
                    assinaturaEletronica={assinaturaEletronica}
                    emitiuReceita={emitiuReceita}
                    onChangeAssinatura={(tipo) => setSelectedMetod(tipo)}
                    onSave={
                        idAgronomo
                        ? async (data) => {
                            return await handlePutAgronomo(idAgronomo, data);
                            }
                        : undefined
                    }
                    update={updateAgronomoInfo}
                    next={() => {
                        setShowContentAcordionCloseAgronomist(true);
                        setStep((prev) => (prev === 1 ? 2 : prev));
                    }}
                    propsLocation={props}
                    isModal={props.isModal}
                    />
                </AcordionCard>
                )}

                {!onlyCrea && listCreasCreated.map((crea, index) => (
                    <AcordionCard
                    key={index}
                    title={
                        crea?.tipo === "crea"
                        ? `CREA: ${crea.crea}`
                        : crea?.tipo === "visto"
                        ? `VISTO: ${crea.crea}`
                        : crea?.tipo === "cfta"
                        ? `CFTA: ${crea.crea}`
                        : "Licença profissional"
                    }
                    isOpen={openCreatedCreaIndex === index}
                    height={false}
                    hasBlock={false}
                    accordionKey={index}
                    onToggle={(key) => {
                        setOpenCreatedCreaIndex((prev) => (prev === key ? null : key));
                    }}
                    showContentAcordionClose={true}
                    contentAcordionClose={
                        <S.ContainerContentAcordionClose>
                        <S.InformationAcordionClose>
                            <TaglineP>UF</TaglineP>

                            <BodyP fontWeight={theme.typography.fontWeight.bold}>
                            {estados.find((e) => e.value === crea.estado)?.label ||
                                crea.estado}
                            </BodyP>
                        </S.InformationAcordionClose>

                        <S.InformationAcordionClose>
                            <TaglineP>Assinatura</TaglineP>

                            <BodyP fontWeight={theme.typography.fontWeight.bold}>
                            {crea?.assinatura === "M"
                                ? "Manual"
                                : crea?.assinatura === "E"
                                ? "Eletrônico"
                                : "Digital"}
                            </BodyP>
                        </S.InformationAcordionClose>

                        <Status status={crea?.status === 1 ? "AT" : "IN"} inactiveLabel="Inativado"></Status>

                        {/* <S.InformationAcordionClose>
                            <TaglineP>Arts ativas</TaglineP>

                            <BodyP fontWeight={theme.typography.fontWeight.bold}>
                            0
                            </BodyP>
                        </S.InformationAcordionClose> */}
                        </S.ContainerContentAcordionClose>
                    }
                    >
                    <S.ContainerCpntentAcordionCard>
                        <div style={{ width: "100%", maxWidth: "430px", display: "flex", flexDirection: "column", gap: "24px" }}>
                        <InputV3
                        id={`tipo_${index}`}
                        type="text"
                        floatingLabel="Tipo de licença"
                        value={
                            crea?.tipo === "crea"
                            ? "CREA"
                            : crea?.tipo === "visto"
                            ? "Visto"
                            : crea?.tipo === "cfta"
                            ? "CFTA"
                            : "Licença profissional"
                        }
                        isDisabled={true}
                        />

                        <InputV3
                        id={`uf_${index}`}
                        type="text"
                        floatingLabel="Estado (UF)"
                        value={
                            estados.find((e) => e.value === crea.estado)?.label ||
                            crea.estado ||
                            ""
                        }
                        isDisabled={true}
                        />

                        <InputV3
                        id={`numero_${index}`}
                        type="text"
                        floatingLabel="Número do documento"
                        value={crea?.crea || ""}
                        isDisabled={true}
                        />

                        {crea?.estado === "SC" ? (
                            <>
                                <InputV3
                                id={`user_${index}`}
                                type="text"
                                floatingLabelWithAsterisk="Usuário SIGEN"
                                value={crea?.usuarioDraft ?? crea?.usuario ?? ""}
                                hasError={crea?.erroUsuario}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setListCreasCreated((prev) =>
                                        prev.map((c) =>
                                        c?.id === crea.id ? { ...c, usuarioDraft: value, erroUsuario: false } : c
                                        )
                                    );
                                }}
                                floatingValue={crea?.usuarioDraft ?? crea?.usuario ?? ""}
                                isDisabled={updatingCreatedCreaId === crea?.id}
                                />

                                <div className="senha" style={{ width: "100%" }}>
                                    <InputV3
                                    id={`pass_${index}`}
                                    type="password"
                                    floatingLabelWithAsterisk="Senha SIGEN"
                                    value={crea?.senhaDraft ?? crea?.senha ?? ""}
                                    hasError={crea?.erroSenha}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setListCreasCreated((prev) =>
                                        prev.map((c) =>
                                            c?.id === crea.id ? { ...c, senhaDraft: value, erroSenha: false } : c
                                        )
                                        );
                                    }}
                                    floatingValue={crea?.senhaDraft ?? crea?.senha ?? ""}
                                    isDisabled={updatingCreatedCreaId === crea?.id}
                                    />
                                </div>
                            </>
                        ) : crea?.estado === "ES" && contractSoftId !== 6 ? (
                            <>
                                <InputV3
                                id={`user_${index}`}
                                type="text"
                                floatingLabelWithAsterisk="Usuário IDAF"
                                value={crea?.usuarioDraft ?? crea?.usuario ?? ""}
                                hasError={crea?.erroUsuario}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setListCreasCreated((prev) =>
                                        prev.map((c) =>
                                        c?.id === crea.id ? { ...c, usuarioDraft: value, erroUsuario: false } : c
                                        )
                                    );
                                }}
                                floatingValue={crea?.usuarioDraft ?? crea?.usuario ?? ""}
                                isDisabled={updatingCreatedCreaId === crea?.id}
                                />

                                <InputV3
                                id={`pass_${index}`}
                                type="password"
                                floatingLabelWithAsterisk="Senha IDAF"
                                value={crea?.senhaDraft ?? crea?.senha ?? ""}
                                hasError={crea?.erroSenha}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setListCreasCreated((prev) =>
                                    prev.map((c) =>
                                        c?.id === crea.id ? { ...c, senhaDraft: value, erroSenha: false } : c
                                    )
                                    );
                                }}
                                floatingValue={crea?.senhaDraft ?? crea?.senha ?? ""}
                                isDisabled={updatingCreatedCreaId === crea?.id}
                                />
                            </>
                        ) : null}

                        <InputV3
                        id={`status_${index}`}
                        type="select"
                        floatingLabelWithAsterisk="Status"
                        isDisabled={updatingCreatedCreaId === crea?.id}
                        options={[
                            { value: 1, label: "Ativo" },
                            { value: 0, label: "Inativo" },
                        ]}
                        typeValueSelect="number"
                        floatingValue={
                            (crea?.statusDraft ?? crea?.status) === 1 ? "Ativo" : "Inativo"
                        }
                        onChange={(selectedOption) => {
                            const nextStatus =
                            typeof selectedOption?.value === "number"
                                ? selectedOption.value
                                : Number(selectedOption?.value);

                            if (isNaN(nextStatus)) return;
                            setListCreasCreated((prev) =>
                            prev.map((c) =>
                                c?.id === crea.id ? { ...c, statusDraft: nextStatus } : c
                            )
                            );
                        }}
                        />
                        </div>

                        {(() => {
                          const selectedMethod = crea?.assinaturaDraft ?? crea?.assinatura;
                          const hasEletronica = !!(
                            crea?.assinaturaEletronicaDraft ||
                            assinaturaEletronicaPadrao ||
                            assinaturaEletronica
                          );
                          const hasDigital = !!(
                            crea?.certificadoDigitalDraft ||
                            (typeof assinaturaDigitalPadrao === "string" &&
                              assinaturaDigitalPadrao.startsWith("data:"))
                          );

                          const selectCreaSignature = (type) => {
                            setListCreasCreated((prev) =>
                              prev.map((c) => {
                                if (c?.id !== crea.id) return c;
                                if (type === "E") {
                                  return {
                                    ...c,
                                    assinaturaDraft: "E",
                                    assinaturaEletronicaDraft:
                                      c?.assinaturaEletronicaDraft ||
                                      assinaturaEletronicaPadrao ||
                                      assinaturaEletronica ||
                                      "",
                                  };
                                }
                                if (type === "D") {
                                  return {
                                    ...c,
                                    assinaturaDraft: "D",
                                    certificadoDigitalDraft:
                                      c?.certificadoDigitalDraft || assinaturaDigitalPadrao || null,
                                    certificadoDigitalNomeDraft:
                                      c?.certificadoDigitalNomeDraft ||
                                      assinaturaDigitalNomePadrao ||
                                      (assinaturaDigitalPadrao ? "certificado_digital.pfx" : ""),
                                  };
                                }
                                return { ...c, assinaturaDraft: "M" };
                              })
                            );
                          };

                          return (
                            <S.SignatureSection isModal={props.isModal}>
                              <SignatureTypeCards
                                value={selectedMethod}
                                onChange={selectCreaSignature}
                                allowedSignatures={crea?.allowedSignatures}
                                estadoValue={crea?.estado}
                                hasElectronicCredential={hasEletronica}
                                hasDigitalCredential={hasDigital}
                                namePrefix={`card_radio_assinatura_created_${index}`}
                                responsavelNome={nome}
                                onUploadCertificado={() => {
                                  setUploadCertModal({ type: "created", creaId: crea.id });
                                }}
                                onCadastrarAssinatura={() =>
                                  setSignatureModal({ type: "created", creaId: crea.id })
                                }
                              />
                            </S.SignatureSection>
                          );
                        })()}

                        <Button
                        width="100%"
                        maxWidth="430px"
                        height="50px"
                        value="Salvar CREA/CFTA/VISTO"
                        outline={false}
                        disabled={updatingCreatedCreaId === crea?.id}
                        onClick={async () => {
                            if (!crea?.id) return;

                            if (crea?.estado === "SC" || (crea?.estado === "ES" && contractSoftId !== 6)) {
                                const usuarioValue = crea?.usuarioDraft ?? crea?.usuario ?? "";
                                const senhaValue = crea?.senhaDraft ?? crea?.senha ?? "";

                                if (!usuarioValue || !senhaValue) {
                                    setListCreasCreated((prev) =>
                                        prev.map((c) =>
                                            c?.id === crea.id
                                                ? {
                                                    ...c,
                                                    erroUsuario: !usuarioValue,
                                                    erroSenha: !senhaValue,
                                                }
                                                : c
                                        )
                                    );

                                    store.addNotification({
                                        title: "Erro!",
                                        message: `Usuário e senha ${crea.estado === "SC" ? "SIGEN" : "IDAF"} são obrigatórios e não podem ficar em branco`,
                                        type: "danger",
                                        insert: "top",
                                        container: "top-right",
                                        animationIn: ["animated", "fadeIn"],
                                        animationOut: ["animated", "fadeOut"],
                                        dismiss: {
                                            duration: 4000,
                                            onScreen: true
                                        }
                                    });
                                    return;
                                }
                            }

                            const nextStatus = crea?.statusDraft ?? crea?.status;
                            const nextAssinatura = crea?.assinaturaDraft ?? crea?.assinatura;
                            let assinaturaEletronicaAtualizada =
                              assinaturaEletronicaPadrao || assinaturaEletronica || "";
                            let shouldSyncAllElectronicSignatures = false;
                            let assinaturaDigitalAtualizada = assinaturaDigitalPadrao || "";
                            let shouldSyncAllDigitalSignatures = false;

                            if (idAgronomo) {
                              let assinaturaPayload = "";
                              let certificadoDigitalNomePayload = "";

                              if (nextAssinatura === "E") {
                                const assinaturaEletronicaToSave =
                                  crea?.assinaturaEletronicaDraft ||
                                  assinaturaEletronicaPadrao ||
                                  assinaturaEletronica ||
                                  "";
                                if (
                                  typeof assinaturaEletronicaToSave === "string" &&
                                  assinaturaEletronicaToSave.startsWith("data:image")
                                ) {
                                  assinaturaPayload = assinaturaEletronicaToSave;
                                }
                              } else if (nextAssinatura === "D") {
                                const certificadoDigitalToSave = crea?.certificadoDigitalDraft;
                                if (
                                  typeof certificadoDigitalToSave === "string" &&
                                  certificadoDigitalToSave.startsWith("data:")
                                ) {
                                  assinaturaPayload = certificadoDigitalToSave;
                                  certificadoDigitalNomePayload = getCertificadoDigitalNome(crea) || "";
                                }
                              } else if (nextAssinatura === "M") {
                                assinaturaPayload = "";
                                certificadoDigitalNomePayload = "";
                              }

                              const updated = await handlePutAgronomo(idAgronomo, {
                                assinatura: assinaturaPayload,
                                certificadoDigitalNome: certificadoDigitalNomePayload,
                              });
                              if (!updated) return;

                              if (nextAssinatura === "E" && assinaturaPayload.startsWith("data:image")) {
                                setAssinaturaEletronica(assinaturaPayload);
                                setAssinaturaEletronicaPadrao(assinaturaPayload);
                                setLicenseForms((prev) =>
                                  prev.map((licenseForm) =>
                                    licenseForm?.selectedMetod === "E"
                                      ? { ...licenseForm, assinaturaEletronica: assinaturaPayload }
                                      : licenseForm
                                  )
                                );
                                assinaturaEletronicaAtualizada = assinaturaPayload;
                                shouldSyncAllElectronicSignatures = true;
                              }

                              if (nextAssinatura === "D" && assinaturaPayload.startsWith("data:")) {
                                setAssinaturaDigitalPadrao(assinaturaPayload);
                                setAssinaturaDigitalNomePadrao(
                                  getCertificadoDigitalNome(crea) || assinaturaDigitalNomePadrao
                                );
                                setLicenseForms((prev) =>
                                  prev.map((licenseForm) =>
                                    licenseForm?.selectedMetod === "D"
                                      ? {
                                          ...licenseForm,
                                          certificadoDigital: assinaturaPayload,
                                          certificadoDigitalNome:
                                            licenseForm?.certificadoDigitalNome ||
                                            getCertificadoDigitalNome(crea) ||
                                            assinaturaDigitalNomePadrao ||
                                            "certificado_digital.pfx",
                                        }
                                      : licenseForm
                                  )
                                );
                                assinaturaDigitalAtualizada = assinaturaPayload;
                                shouldSyncAllDigitalSignatures = true;
                              }
                            }

                            const ok = await updateCreatedCreaStatus(
                            crea,
                            nextStatus,
                            nextAssinatura,
                            crea?.usuarioDraft ?? crea?.usuario ?? "",
                            crea?.senhaDraft ?? crea?.senha ?? ""
                            );
                            if (!ok) return;

                            setListCreasCreated((prev) =>
                            prev.map((c) =>
                                c?.id === crea.id
                                ? {
                                    ...c,
                                    status: nextStatus,
                                    statusDraft: undefined,
                                    assinatura: nextAssinatura,
                                    assinaturaDraft: undefined,
                                    assinaturaEletronicaDraft:
                                      nextAssinatura === "E"
                                        ? c?.assinaturaEletronicaDraft ||
                                          assinaturaEletronicaAtualizada ||
                                          ""
                                        : c?.assinaturaEletronicaDraft,
                                    certificadoDigitalDraft:
                                      nextAssinatura === "D"
                                        ? c?.certificadoDigitalDraft ||
                                          assinaturaDigitalAtualizada ||
                                          null
                                        : c?.certificadoDigitalDraft,
                                    certificadoDigitalNomeDraft:
                                      nextAssinatura === "D"
                                        ? c?.certificadoDigitalNomeDraft ||
                                          assinaturaDigitalNomePadrao ||
                                          (assinaturaDigitalAtualizada
                                            ? "certificado_digital.pfx"
                                            : "")
                                        : c?.certificadoDigitalNomeDraft,
                                    }
                                : shouldSyncAllElectronicSignatures &&
                                  (c?.assinaturaDraft ?? c?.assinatura) === "E"
                                ? {
                                    ...c,
                                    assinaturaEletronicaDraft: assinaturaEletronicaAtualizada,
                                  }
                                : shouldSyncAllDigitalSignatures &&
                                  (c?.assinaturaDraft ?? c?.assinatura) === "D"
                                ? {
                                    ...c,
                                    certificadoDigitalDraft: assinaturaDigitalAtualizada,
                                    certificadoDigitalNomeDraft:
                                      c?.certificadoDigitalNomeDraft ||
                                      assinaturaDigitalNomePadrao ||
                                      "certificado_digital.pfx",
                                  }
                                : c
                            )
                            );
                        }}
                        loading={updatingCreatedCreaId === crea?.id || assinaturaLoading}
                        />
                    </S.ContainerCpntentAcordionCard>
                    </AcordionCard>
                ))}

                {licenseForms.map((form, index) => {
                    const licenseTitle =
                        form.crea?.tipo === "crea"
                        ? `CREA: ${form.crea.crea}`
                        : form.crea?.tipo === "visto"
                        ? `VISTO: ${form.crea.crea}`
                        : form.crea?.tipo === "cfta"
                        ? `CFTA: ${form.crea.crea}`
                        : "Licença profissional";

                    const licenseContent = (
                    <S.ContainerCpntentAcordionCard>
                        <div style={{ width: "100%", maxWidth: "430px", display: "flex", flexDirection: "column", gap: "24px" }}>
                        <InputV3
                        id="licenca"
                        type="select"
                        floatingLabelWithAsterisk="Tipo de licença"
                        value={form.licenca.label}
                        onChange={(selectedOption) => {
                            setErroLicenca(false);

                            updateLicenseForm(index, "licenca", {
                            value: selectedOption.value,
                            label: selectedOption.label,
                            });
                            
                            if(selectedOption.value === 'cfta') {
                                updateLicenseForm(index, "estadoLicenca", { value: "NACIONAL", label: "Nacional" });
                            }

                            updateLicenseForm(index, "erroLicenca", false);
                        }}
                        options={[
                            { value: "crea", label: "CREA" },
                            { value: "visto", label: "Visto" },
                            { value: "cfta", label: "CFTA" },
                        ]}
                        hasError={form.erroLicenca || erroLicenca}
                        errorInfo={""}
                        floatingValue={form.licenca.label}
                        />

                        <SelectV2Multi
                        height="auto"
                        marginBottom={form.licenca?.value === 'cfta' ? '0px' : '24px'}
                        name="estado"
                        className="select"
                        label="Estado (UF)"
                        labelWithAsterisk={true}
                        id="estado"
                        value={form.estadoLicenca?.value || form.estadoLicenca || ""}
                        disabled={form.licenca?.value === 'cfta'}
                        loading={false}
                        erro={form.erroEstado}
                        messageErro={""}
                        onChange={async (selectedOption) => {
                            updateLicenseForm(index, "estadoLicenca", selectedOption);
                            
                            if(selectedOption.value === 'NACIONAL') {
                                updateLicenseForm(index, "licenca", { value: "cfta", label: "CFTA" });
                            }
                            
                            if(selectedOption.value) {
                                const allowed = await getTiposAssinatura(selectedOption.value);
                                updateLicenseForm(index, "allowedSignatures", allowed);

                                // Se a assinatura selecionada não for permitida, reseta para manual ou a primeira permitida
                                const form = licenseForms[index];
                                if (!allowed.includes(form.selectedMetod)) {
                                    updateLicenseForm(index, "selectedMetod", allowed.includes('M') ? 'M' : allowed[0]);
                                }

                                // Preenche usuário/senha (SIGEN para SC, IDAF para ES) já cadastrados
                                // para este responsável técnico, se ainda não preenchidos neste formulário
                                const agronomoIdParaCredenciais = idAgronomo || idFromRoute;
                                if (
                                    (selectedOption.value === 'SC' || selectedOption.value === 'ES') &&
                                    agronomoIdParaCredenciais &&
                                    !form.usuario &&
                                    !form.senha
                                ) {
                                    try {
                                        const responseUser = await api.get(
                                            `/agronomos/usuario/${agronomoIdParaCredenciais}/${selectedOption.value}`
                                        );
                                        const credenciais = responseUser?.data?.data;
                                        if (credenciais?.usuario && credenciais?.senha) {
                                            updateLicenseForm(index, "usuario", credenciais.usuario);
                                            updateLicenseForm(index, "senha", credenciais.senha);
                                        }
                                    } catch (erroCredenciais) {
                                        // Nenhuma credencial cadastrada ainda para este estado - usuário preenche manualmente
                                    }
                                }
                            } else {
                                // Se limpar o estado, permite todas
                                updateLicenseForm(index, "allowedSignatures", ['M', 'D', 'E']);
                            }

                            updateLicenseForm(index, "erroEstado", false);
                        }}
                        options={[...estados, { value: "NACIONAL", label: "Nacional" }]}
                        selectUniqueOption={true}
                        buttonAddNew={false}
                        isModal={true}
                        isClearable={true}
                        labelColor="#8A92A2"
                        labelMarginLeft="14px"
                        inputColor="#21262F"
                        InputFontSize="14px"
                        InputFontWeight="400"
                        InputPadding="13px 65px 12px 14px"
                        colorBorder="solid 1px #8A92A2"
                        />

                        <InputV3
                        id="licenca"
                        type="text"
                        floatingLabelWithAsterisk="Número do documento"
                        value={form.numeroLicenca}
                        onChange={(e) => {
                            updateLicenseForm(index, "numeroLicenca", e.target.value);
                            updateLicenseForm(index, "erroNumeroLicenca", false);
                        }}
                        hasError={form.erroNumeroLicenca}
                        errorInfo={""}
                        floatingValue={form.numeroLicenca}
                        handleClear={() => {
                            updateLicenseForm(index, "numeroLicenca", "");
                        }}
                        />

                        {form.estadoLicenca?.value === "RJ" && (
                            <InputV3
                                id="receita_inicial"
                                type="text"
                                floatingLabelWithAsterisk="Receita Inicial"
                                value={form.receitaInicial}
                                onChange={(e) => {
                                    updateLicenseForm(index, "receitaInicial", e.target.value);
                                    updateLicenseForm(index, "erroReceitaInicial", false);
                                }}
                                hasError={form.erroReceitaInicial}
                                errorInfo={""}
                                floatingValue={form.receitaInicial}
                            />
                        )}

                        {(form.estadoLicenca?.value === "SC" || form.estadoLicenca === "SC") ? (
                            <>
                                <InputV3
                                    id="user"
                                    type="text"
                                    floatingLabelWithAsterisk="Usuário SIGEN"
                                    value={form.usuario}
                                    onChange={(e) => {
                                        updateLicenseForm(index, "usuario", e.target.value);
                                        updateLicenseForm(index, "erroUsuario", false);
                                    }}
                                    hasError={form.erroUsuario}
                                    errorInfo={""}
                                    floatingValue={form.usuario}
                                />

                                <div className="senha" style={{ width: "100%" }}>
                                    <InputV3
                                        id="pass"
                                        type="password"
                                        floatingLabelWithAsterisk="Senha SIGEN"
                                        value={form.senha}
                                        onChange={(e) => {
                                            updateLicenseForm(index, "senha", e.target.value);
                                            updateLicenseForm(index, "erroSenha", false);
                                        }}
                                        hasError={form.erroSenha}
                                        errorInfo={""}
                                        floatingValue={form.senha}
                                    />
                                </div>
                            </>
                        ) : (<>
                            {(form.estadoLicenca?.value === "ES" || form.estadoLicenca === "ES") && contractSoftId != 6 ? (
                                <>
                                    <InputV3
                                        id="user"
                                        type="text"
                                        floatingLabelWithAsterisk="Usuário IDAF"
                                        value={form.usuario}
                                        onChange={(e) => {
                                            updateLicenseForm(index, "usuario", e.target.value);
                                            updateLicenseForm(index, "erroUsuario", false);
                                        }}
                                        hasError={form.erroUsuario}
                                        errorInfo={""}
                                        floatingValue={form.usuario}
                                    />

                                    <InputV3
                                        id="pass"
                                        type="password"
                                        floatingLabelWithAsterisk="Senha IDAF"
                                        value={form.senha}
                                        onChange={(e) => {
                                            updateLicenseForm(index, "senha", e.target.value);
                                            updateLicenseForm(index, "erroSenha", false);
                                        }}
                                        hasError={form.erroSenha}
                                        errorInfo={""}
                                        floatingValue={form.senha}
                                    />
                                </>
                            ) : (
                                null
                            )}
                        </>)}

                        <InputV3
                        id="filial"
                        type="select"
                        typeValueSelect="number"
                        floatingLabelWithAsterisk="Filial"
                        value={form.filial.label}
                        onChange={(selectedOption) => {
                            updateLicenseForm(index, "filial", {
                            value: selectedOption.value,
                            label: selectedOption.label,
                            });
                            updateLicenseForm(index, "erroFilial", false);
                        }}
                        options={filiaisOptions}
                        hasError={form.erroFilial}
                        errorInfo={""}
                        floatingValue={form.filial.label}

                        />
                        </div>

                        {(() => {
                          const estadoValue = form.estadoLicenca?.value || form.estadoLicenca || "";
                          if (!estadoValue) return null;

                          const hasEletronica = !!(
                            form.assinaturaEletronica || assinaturaEletronicaPadrao || assinaturaEletronica
                          );
                          const hasDigital = !!(
                            form.certificadoDigitalNome ||
                            form.certificadoDigital ||
                            (typeof assinaturaDigitalPadrao === "string" && assinaturaDigitalPadrao.startsWith("data:"))
                          );

                          const selectFormSignature = (type) => {
                            updateLicenseForm(index, "selectedMetod", type);
                            updateLicenseForm(index, "erroMetodo", false);
                            if (type === "E") {
                              updateLicenseForm(
                                index,
                                "assinaturaEletronica",
                                form.assinaturaEletronica || assinaturaEletronicaPadrao || assinaturaEletronica || ""
                              );
                            }
                            if (type === "D") {
                              updateLicenseForm(
                                index,
                                "certificadoDigital",
                                form.certificadoDigital || assinaturaDigitalPadrao || null
                              );
                              updateLicenseForm(
                                index,
                                "certificadoDigitalNome",
                                form.certificadoDigitalNome ||
                                  assinaturaDigitalNomePadrao ||
                                  (assinaturaDigitalPadrao ? "certificado_digital.pfx" : "")
                              );
                            }
                          };

                          return (
                            <S.SignatureSection isModal={props.isModal}>
                              <SignatureTypeCards
                                value={form.selectedMetod}
                                onChange={selectFormSignature}
                                allowedSignatures={form.allowedSignatures}
                                estadoValue={estadoValue}
                                hasElectronicCredential={hasEletronica}
                                hasDigitalCredential={hasDigital}
                                namePrefix={`card_radio_assinatura_${index}`}
                                responsavelNome={nome}
                                onUploadCertificado={() => {
                                  setUploadCertModal({ type: "license", index });
                                }}
                                onCadastrarAssinatura={() => setSignatureModal({ type: "license", index })}
                              />
                            </S.SignatureSection>
                          );
                        })()}

                        <div
                        className="button-finish"
                        style={{
                            width: "100%",
                            padding: "0 15px",
                        }}
                        >
                          <Button
                              width="100%"
                              maxWidth="430px"
                              margin="0 auto"
                              height="50px"
                              value="Salvar CREA/CFTA/VISTO"
                              outline={false}
                              disabled={savingLicenseIndex !== null}
                              onClick={() => handleCreateAgronomistAndCrea(null, index)}
                              loading={savingLicenseIndex === index || assinaturaLoading}
                          />
                        </div>
                    </S.ContainerCpntentAcordionCard>
                    );

                    if (onlyCrea) {
                        return (
                            <div key={form.id} style={{ width: "100%" }}>
                                <H6 style={{ marginBottom: "16px" }}>{licenseTitle}</H6>
                                {licenseContent}
                            </div>
                        );
                    }

                    return (
                        <AcordionCard
                        key={form.id}
                        title={licenseTitle}
                        isOpen={form.isOpen && (step !== 1 || !!idAgronomo)}
                        height={true}
                        hasBlock={step === 1 && !idAgronomo}
                        showContentAcordionClose={false}
                        onClick={() => toggleLicenseForm(index)}
                        >
                            {licenseContent}
                        </AcordionCard>
                    );
                })}

                {!onlyCrea && (
                <S.Button
                    onClick={() => {
                    setErroLicenca(false);
                    setLicenseForms([
                        ...licenseForms,
                        {
                        id: Date.now(),
                        licenca: "",
                        estadoLicenca: "",
                        numeroLicenca: "",
                        filial: filiaisOptions.length === 1 ? filiaisOptions[0] : "",
                        selectedMetod: assinaturaDigitalPadrao
                          ? "D"
                          : assinaturaEletronicaPadrao
                          ? "E"
                          : "M",
                        receitaInicial: "",
                        assinaturaEletronica: assinaturaEletronicaPadrao || "",
                        certificadoDigital: assinaturaDigitalPadrao || null,
                        certificadoDigitalNome: assinaturaDigitalPadrao
                          ? assinaturaDigitalNomePadrao || "certificado_digital.pfx"
                          : "",
                        allowedSignatures: ['M', 'D', 'E'],
                        erroLicenca: false,
                        erroEstado: false,
                        erroNumeroLicenca: false,
                        erroFilial: false,
                        erroMetodo: false,
                        isOpen: true,
                        },
                    ]);
                    }}
                >
                    <img src={plus} alt="Adicionar" />

                    <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>
                    cadastrar nova Licença
                    </TaglineM>
                </S.Button>
                )}

                <ModalPassword
                  text={"Precisamos da sua senha para validar a autenticidade do certificado. Para sua segurança, essa senha não ficará salva em nossos servidores."}
                  show={showModal}
                  update={(e) => updatePassword(e)}
                  onHide={closeModalPassword}
                />

                <Modal
                  show={!!uploadCertModal}
                  onHide={() => fecharUploadCertModal()}
                  align="center"
                  justify="center"
                  responsive
                  width="480px"
                >
                  <ModalTitle>Upload do certificado digital</ModalTitle>

                  <ModalBody>
                    <PlanilhaDropzone
                      descricao="O upload do certificado é necessário caso deseje assinar sua receita digitalmente."
                      chamada="Arraste o certificado aqui"
                      legenda="PFX de até 3 MB"
                      accept={CERTIFICADO_ACCEPT}
                      arquivo={
                        certificadoSelecionado
                          ? {
                              nome: certificadoSelecionado.name,
                              tamanho: formatFileSize(certificadoSelecionado.size),
                              extensao: certificadoSelecionado.name.split(".").pop() || "",
                            }
                          : null
                      }
                      onSelect={(fileSelected) => setCertificadoSelecionado(fileSelected)}
                      onRemove={() => setCertificadoSelecionado(null)}
                      onReject={(motivo) =>
                        store.addNotification({
                          title: "Erro!",
                          message: motivo,
                          type: "danger",
                          insert: "top",
                          container: "top-right",
                          animationIn: ["animated", "fadeIn"],
                          animationOut: ["animated", "fadeOut"],
                          dismiss: { duration: 4000, onScreen: true },
                        })
                      }
                    />

                    <div style={{ width: "100%", marginTop: "16px" }}>
                      <Button
                        width="100%"
                        height="50px"
                        value="SALVAR"
                        outline={false}
                        disabled={!certificadoSelecionado}
                        onClick={() => salvarCertificadoSelecionado()}
                        loading={false}
                      />
                    </div>
                  </ModalBody>
                </Modal>

                <Modal
                  show={!!signatureModal}
                  onHide={() => setSignatureModal(null)}
                  align="center"
                  justify="center"
                  responsive
                  width="480px"
                >
                  <ModalTitle>Cadastrar assinatura eletrônica</ModalTitle>

                  <ModalBody>
                    <InputSign
                      key={signatureModal ? `${signatureModal.type}-${signatureModal.creaId ?? signatureModal.index}` : "none"}
                      sign={getSignatureModalValue()}
                      update={(value) => updateSignatureModalValue(value)}
                    />
                  </ModalBody>
                </Modal>
            </>
        )}
        </S.Wrapper>
      </S.Container>
    </>
  );
};
export default withRouter(EditCreaV2);
